// API and Data URLs
export const DATA_BASE_URL = import.meta.env.DEV
  ? 'http://localhost:8080'
  : '';

export const DATA_PATHS = {
  PROFILE_PICTURE: `${DATA_BASE_URL}/data/PROFILE PICTURE SRIHAAN.webp`,
  CV: `${DATA_BASE_URL}/data/Srihaan Poddar CV.pdf`,
  INTRODUCTION: `${DATA_BASE_URL}/data/INTRODUCTION SRIHAAN.pdf`,
};

// Gallery Images organized by category
export const GALLERY_IMAGES = {
  chess: [
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/national_chess_champion_dapitan_2024.webp`,
      title: 'National Chess Champion Dapitan 2024',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/national_chess_championship_dapitan_2024.webp`,
      title: 'National Chess Championship Dapitan 2024',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/national_champion_malolos_2022.webp`,
      title: 'National Champion Malolos 2022',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/thailand_champion.webp`,
      title: 'Thailand Chess Champion',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/thailand_tournament.webp`,
      title: 'Thailand Chess Tournament',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/national_champion_dapitan_under16.webp`,
      title: 'National Champion Dapitan Under 16',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/regional_champion_1.webp`,
      title: 'Regional Chess Champion',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/regional_champion_2.webp`,
      title: 'Regional Chess Champion',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/shanghai_tournament.webp`,
      title: 'Shanghai Chess Tournament',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/west_bengal_state_level.webp`,
      title: 'West Bengal State Level Tournament',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/international_tournament.webp`,
      title: 'International Chess Tournament',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/tournaments/php_national_chess_venue.webp`,
      title: 'Philippines National Chess Venue',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/recognitions/national_master_title_2023.webp`,
      title: 'National Master Title 2023',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/recognitions/ncfp_special_recognition_oct2024.webp`,
      title: 'NCFP Special Recognition Oct 2024',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/recognitions/paref_southridge_chess_champion.webp`,
      title: 'PAREF Southridge Chess Champion',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/recognitions/inmate_chess_1.webp`,
      title: 'Prison Chess Initiative',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/recognitions/inmate_chess_2.webp`,
      title: 'Prison Chess Mentorship',
      category: 'chess',
    },
    {
      src: `${DATA_BASE_URL}/data/chess/achievements/trophies_and_medals_collage.webp`,
      title: 'Chess Trophies and Medals',
      category: 'chess',
    },
  ],
  robotics: [
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_competition_2024_1.webp`,
      title: 'FRC Sydney Competition 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_competition_2024_2.webp`,
      title: 'FRC Sydney Competition 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_robot_2024.webp`,
      title: 'FRC Sydney Robot 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_rookie_award_ceremony_2024.webp`,
      title: 'FRC Sydney Rookie Award Ceremony 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_rookie_inspiration_award_2024.webp`,
      title: 'FRC Sydney Rookie Inspiration Award 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_team_photo_2024.webp`,
      title: 'FRC Sydney Team Photo 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_sydney_team_tsinelas_2024.webp`,
      title: 'FRC Sydney Team Tsinelas 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_taipei_finalist_2025.webp`,
      title: 'FRC Taipei Finalist 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_taipei_pit_area_2025.webp`,
      title: 'FRC Taipei Pit Area 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/frc_taipei_robot_2025.webp`,
      title: 'FRC Taipei Robot 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/team_photo_1.webp`,
      title: 'Robotics Team Photo',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/team_photo_2025_oct.webp`,
      title: 'Robotics Team Photo Oct 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2023_1.webp`,
      title: 'VEX Robotics 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2023_2.webp`,
      title: 'VEX Robotics 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2023_3.webp`,
      title: 'VEX Robotics 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2023_4.webp`,
      title: 'VEX Robotics 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2023_5.webp`,
      title: 'VEX Robotics 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2023_6.webp`,
      title: 'VEX Robotics 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2025_1.webp`,
      title: 'VEX Robotics 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_2025_2.webp`,
      title: 'VEX Robotics 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_dallas_2025_1.webp`,
      title: 'VEX Dallas 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_dallas_2025_2.webp`,
      title: 'VEX Dallas 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_dallas_team_2025.webp`,
      title: 'VEX Dallas Team 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_excellence_award_philippines_nationals_2024.webp`,
      title: 'VEX Excellence Award Philippines Nationals 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_philippines_national_award_2024.webp`,
      title: 'VEX Philippines National Award 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_philippines_nationals_2024.webp`,
      title: 'VEX Philippines Nationals 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_robot_design_nationals_2024.webp`,
      title: 'VEX Robot Design Nationals 2024',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_1.webp`,
      title: 'VEX Taipei 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_2.webp`,
      title: 'VEX Taipei 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_taipei_2025_3.webp`,
      title: 'VEX Taipei 2025',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_team_award_2023.webp`,
      title: 'VEX Team Award 2023',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/vex_worlds_2022.webp`,
      title: 'VEX World Championship 2022',
      category: 'robotics',
    },
    {
      src: `${DATA_BASE_URL}/data/robotics/images/working_on_robot.webp`,
      title: 'Working on Robot',
      category: 'robotics',
    },
  ],
  sports: [
    {
      src: `${DATA_BASE_URL}/data/badminton/photos/badminton_25.webp`,
      title: 'Badminton 2025',
      category: 'sports',
    },
    {
      src: `${DATA_BASE_URL}/data/badminton/photos/badminton_singapore_25.webp`,
      title: 'Badminton Singapore 2025',
      category: 'sports',
    },
    {
      src: `${DATA_BASE_URL}/data/badminton/photos/iasas_singapore_25_badminton_team_ism.webp`,
      title: 'IASAS Singapore 2025 Badminton Team ISM',
      category: 'sports',
    },
    {
      src: `${DATA_BASE_URL}/data/badminton/photos/varsity_badminton.webp`,
      title: 'Varsity Badminton',
      category: 'sports',
    },
  ],
  'social-impact': [
    {
      src: `${DATA_BASE_URL}/data/social_impact/kolkata/kolkata_chess.webp`,
      title: 'Kolkata Chess Initiative',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/kolkata/kolkata_dog_1.webp`,
      title: 'Kolkata Animal Welfare',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/kolkata/kolkata_dog_2.webp`,
      title: 'Kolkata Animal Care',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/kolkata/kolkata_general.webp`,
      title: 'Kolkata Community Service',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/media/ph_amateur_chess_2024.webp`,
      title: 'Philippines Amateur Chess 2024',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/prison_chess/inmate_chess_1.webp`,
      title: 'Prison Chess Initiative',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/prison_chess/inmate_chess_2.webp`,
      title: 'Prison Chess Mentorship',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/prison_chess/inmate_simultaneous_game.webp`,
      title: 'Prison Chess Simultaneous Exhibition',
      category: 'social-impact',
    },
    {
      src: `${DATA_BASE_URL}/data/social_impact/prison_chess/prison_chess_image.webp`,
      title: 'Prison Chess Program',
      category: 'social-impact',
    },
  ],
  awards: [
    {
      src: `${DATA_BASE_URL}/data/awards/photos/national_honor_society_2025.webp`,
      title: 'National Honor Society 2025',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/mathematics_department_award_2023.webp`,
      title: 'Mathematics Department Award 2023',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/mathematics_department_award_2023_alt.webp`,
      title: 'Mathematics Department Award 2023',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/mathematics_honors_society_2025.webp`,
      title: 'Mathematics Honors Society 2025',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/spanish_honors_society_2025.webp`,
      title: 'Spanish Honors Society 2025',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/iasas_scholar_award_2025.webp`,
      title: 'IASAS Scholar Award 2025',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/national_master_title_2023.webp`,
      title: 'National Master Title 2023',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/plaque_award_ncfp.webp`,
      title: 'Plaque Award NCFP',
      category: 'awards',
    },
    {
      src: `${DATA_BASE_URL}/data/awards/photos/plaque_recognition_chess_php_2024.webp`,
      title: 'Plaque Recognition Chess Philippines 2024',
      category: 'awards',
    },
  ],
};

// Flatten all gallery images for "All" filter
export const ALL_GALLERY_IMAGES = [
  ...GALLERY_IMAGES.chess,
  ...GALLERY_IMAGES.robotics,
  ...GALLERY_IMAGES.sports,
  ...GALLERY_IMAGES['social-impact'],
  ...GALLERY_IMAGES.awards,
];

// Gallery filter categories
export const GALLERY_CATEGORIES = [
  { id: 'all', label: 'All Photos', icon: 'academics' },
  { id: 'chess', label: 'Chess', icon: 'chess' },
  { id: 'robotics', label: 'Robotics', icon: 'robotics' },
  { id: 'sports', label: 'Sports', icon: 'badminton' },
  { id: 'social-impact', label: 'Social Impact', icon: 'social-impact' },
  { id: 'awards', label: 'Awards & Recognition', icon: 'experience' },
];

// Navigation Links
export const NAV_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/academics', label: 'Academics' },
  { path: '/experienceandresearch', label: 'Experience & Research' },
  { path: '/chess', label: 'Chess' },
  { path: '/robotics', label: 'Robotics' },
  { path: '/social-impact', label: 'Social Impact' },
  { path: '/sports', label: 'Badminton' },
  { path: '/music', label: 'Music' },
  { path: '/gallery', label: 'Gallery' },
  { path: '/contact', label: 'Contact' },
];

// Social Media Links
export const SOCIAL_LINKS = {
  email: 'poddars@ismanila.org',
  phone: '+63 9178928711',
  github: 'https://github.com/Sri-SriPod',
  linkedin: 'https://www.linkedin.com/in/srihaan-poddar-a5b37738a/',
  lichess: '#', // Add when available
};

// Site Metadata
export const SITE_INFO = {
  name: 'Srihaan Poddar',
  tagline: 'Student @ International School Manila l National Chess Champion, Robotics & Badminton Enthusiast',
  description: 'Portfolio showcasing achievements in chess, robotics, academics, and social impact.',
  location: 'Manila, Philippines',
};

// Stats for Home Page
export const STATS = [
  { label: 'National Chess Championships', value: '3' },
  { label: 'Funds Raised (USD)', value: '4000+' },
  { label: 'Robotics Competitions', value: '15+' },
  { label: 'Students Mentored', value: '100+' },
];

// Internships Data - Centralized source of truth
export const INTERNSHIPS_DATA = [
  {
    id: 'schoolhouse',
    company: 'Schoolhouse.world',
    location: 'Remote',
    role: 'Certified Tutor',
    period: 'Jun 2025 - Present',
    date: 'June 2025',
    duration: '5 mos',
    icon: 'books',
    description: 'Certified tutor on Schoolhouse.world: As certified tutor on Schoolhouse.world, promoted STEM access by tutoring IB Math, AP Calculus, Chemistry & SAT via Schoolhouse.',
    achievements: [
      'Became certified tutor on Schoolhouse.world platform',
      'Tutored students in IB Math, AP Calculus, and Chemistry',
      'Provided SAT preparation and academic support',
      'Promoted STEM education access to underserved students',
      'Conducted online tutoring sessions via Schoolhouse platform',
    ],
    skills: ['Math', 'Chemistry', 'Teaching', 'SAT Prep', 'Online Education'],
    impact: 'Promoted STEM access through tutoring',
    type: 'education',
  },
  {
    id: 'albertson',
    company: 'Albertsons Companies Inc.',
    location: 'Philippines',
    role: 'iPad App Developer Intern',
    period: 'June 2024',
    date: 'June 2024',
    duration: '2 weeks',
    icon: 'cart',
    certificate: `${DATA_BASE_URL}/data/internships/albertson/albertson_internship_2024.pdf`,
    description: 'Enhanced an iPad application program using Python for a retail store, enabling "self-check-in" for staff.',
    achievements: [
      'Selected from competitive pool of ISM applicants spanning grades 9-12',
      'Reduced telephone calls to corporate helpdesk by 100,000 (30% decrease)',
      'Application deployed in 2,000+ stores nationwide',
      'Name embedded into program as legacy recognition',
    ],
    highlights: [
      'First professional internship experience',
      'Enhanced retail iPad application using Python',
      'Reduced helpdesk calls by 30%',
      'Application deployed nationwide to 2,000+ stores',
    ],
    skills: ['Python', 'iOS Development', 'Problem Solving', 'Retail Tech'],
    impact: 'Deployed in 2,000+ stores',
    type: 'retail-tech',
  },
  {
    id: 'omind',
    company: 'Omind',
    location: 'USA',
    role: 'AI Agent Development Intern',
    period: 'June - July 2025',
    date: 'June - July 2025',
    duration: '2 months',
    icon: 'robot',
    certificate: `${DATA_BASE_URL}/data/internships/omind/omind_internship_certificate_2025.pdf`,
    projectDoc: `${DATA_BASE_URL}/data/internships/omind/omind_project_documentation_2025.pdf`,
    description: 'Developed an AI support agent ("Jarvis") using Python and Google ADK to help users troubleshoot laptop issues.',
    achievements: [
      'Built AI agent using LLMs and RAG architecture',
      'Applied advanced prompt engineering techniques',
      'Integrated Google APIs for real-time search',
      'Explored automation tools like Synthflow and Make.com',
      'Refined agent behavior through iterative testing',
    ],
    highlights: [
      'Most recent and advanced internship',
      'Built AI support agent "Jarvis" from scratch',
      'Applied LLMs, RAG, and prompt engineering',
      'Integrated real-time Google APIs',
    ],
    skills: ['Python', 'AI/ML', 'LLMs', 'RAG', 'Google APIs', 'Prompt Engineering'],
    impact: 'Created intelligent support system',
    type: 'ai-ml',
  },
  {
    id: 'philtech',
    company: 'SRP Technologies (Honda Manufacturing)',
    location: 'Manesar, Haryana, India',
    role: 'Tech Intern - Robotics & Automation',
    period: '2024',
    date: 'Summer 2024',
    duration: 'Summer',
    icon: 'robotics',
    certificate: `${DATA_BASE_URL}/data/internships/philtech/philtech_internship_2024.pdf`,
    description: 'Assisted in robotic system deployment at Honda\'s manufacturing unit, gaining first-hand exposure to automation processes.',
    achievements: [
      'Observed AI-driven robots in assembly lines',
      'Supported configuration tasks for robotic systems',
      'Shadowed senior engineers during system checks',
      'Documented machine responsiveness and workflow sequencing',
      'Studied industrial safety protocols',
    ],
    highlights: [
      'First exposure to industrial-scale automation',
      'Observed AI-driven robots in assembly lines',
      'Documented safety protocols and workflows',
      'Learned from senior engineers at Honda',
    ],
    skills: ['Robotics', 'Automation', 'Industrial Systems', 'Safety Protocols', 'Documentation'],
    impact: 'Large-scale industrial production exposure',
    type: 'robotics',
  },
];

// Research Data - Centralized source of truth
export const RESEARCH_DATA = {
  papers: [
    {
      id: 'ai-in-chess',
      title: 'The Algorithmic Grandmaster: AI in Chess',
      fullTitle:
        'The Algorithmic Grandmaster: Charting the Ascent and Pervasive Influence of Artificial Intelligence in Chess',
      abstract:
        'The old chess game that used to be viewed as one of the citadels of human thought turned out to be a problem of artificial intelligence (AI) growth and use. This paper provides a detailed account of AI history development, its technological progression, and its significant effect on chess. It traces the evolution from theoretical models to the brute computing of Deep Blue (1997) to the revolutionary AlphaZero system.',
      year: '2024',
      topics: ['Artificial Intelligence', 'Chess', 'Machine Learning', 'AlphaZero', 'Deep Blue'],
      file: `${DATA_BASE_URL}/data/research/ai_in_chess.pdf`,
      isPdf: true,
    },
  ],
  experiences: [
    {
      id: 'self-driving-vehicles',
      title: 'Research Assistant – Self Driving Vehicles',
      institution: 'University of Petroleum and Energy Studies, India',
      supervisor: 'Dr. J.K Pandey',
      abstract:
        'Analyzed feasibility of autonomous cars in Indian Traffic under Dr. J.K Pandey; co-authored simulations adapting global models to local road conditions',
      year: '2024',
      topics: [
        'Autonomous Vehicles',
        'Traffic Analysis',
        'Simulation Modeling',
        'Self-Driving Technology',
        'Indian Traffic Conditions',
      ],
    },
  ],
};
